@if (isNotEmpty(points) || isNotEmpty(bboxes)) {
  <div>
    <ds-metadata-field-wrapper [label]="label | translate">
      @defer {
        <ds-geospatial-map [coordinates]="this.points"
                           [bbox]="this.bboxes"
                           [cluster]="this.cluster"
                           [layout]="'item'"
                           style="width: 100%;">
        </ds-geospatial-map>
      }
    </ds-metadata-field-wrapper>
  </div>
}
